import {
	Card,
	CardBody,
	CardHeader,
	CardHeading,
	FormikWithRedirectForm,
	Loading,
	MultiSelectField,
	SubmitButton,
	isSuccess,
	useToasts,
} from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useContactViewsQuery } from "../shared/api/contactViewService";
import { useUserPreferencesQuery } from "../shared/api/userPreferencesQueries";
import { userPreferencesService } from "../shared/api/userPreferencesService";
import { UserPreferencesFormValues } from "../shared/types/userPreferences";

const Actions = styled.div`
	display: flex;
	justify-content: end;
`;

const StyledCard = styled(Card)`
	margin: ${({ theme }) => theme.spacing(8)};
`;

export const UserPreferencesPage: FC = () => {
	const { t } = useTranslation();
	const { userPreferences } = useUserPreferencesQuery();
	const { data: contactViews } = useContactViewsQuery();
	const { showToast } = useToasts();
	const queryClient = useQueryClient();

	const handleSubmit = async (values: UserPreferencesFormValues) => {
		const result = await userPreferencesService.update({ contactViewIds: values.contactViews.map((v) => v.id) });

		if (isSuccess(result)) {
			showToast({ title: t("Preferences"), type: "success", body: t("Preferences saved successfully.") });
			void queryClient.invalidateQueries({ queryKey: userPreferencesService.showKey });
			return true;
		}

		return false;
	};

	return (
		<StyledCard>
			<CardHeader>
				<CardHeading>{t("Preferences")}</CardHeading>
			</CardHeader>
			<CardBody>
				{userPreferences === undefined ? (
					<Loading />
				) : (
					<FormikWithRedirectForm onSubmit={handleSubmit} initialValues={userPreferences}>
						<MultiSelectField label={t("Favorite contact views")} name="contactViews" options={contactViews} />
						<Actions>
							<SubmitButton>{t("Save")}</SubmitButton>
						</Actions>
					</FormikWithRedirectForm>
				)}
			</CardBody>
		</StyledCard>
	);
};
